<template>
  <div
    id="mobile-menu-container"
    class="mobile-menu-container"
    :class="{ open: isMenuOpen, 'set-transparent-background': !isScrolled, 'unset-transparent-background': isScrolled }"
  >
    <div class="mobile-menu-header">
      <div class="mobile-menu-icon-container">
        <img
          @click="selectHomeOption('producto') & headerGA4Click('click', 'producto', 'header')"
          :src="tecateLogo"
          alt="Logo_Tecate0.0"
        />
      </div>
      <div class="hamburguer-container">
        <div id="nav-icon3" :class="{ open: isMenuOpen, unscrolled: !isScrolled, scrolled: isScrolled }" @click="openMenu()">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </div>
    <div class="mobile-menu-row">
      <div class="mobile-menu-options-container">
        <div class="mobile-menu-row-icon">
          <img
            @click="selectHomeOption('producto') & headerGA4Click('click', 'producto', 'header')"
            :src="tecateLogo_black"
            alt="Logo_Tecate0.0"
          />
        </div>
        <div
          @click="selectMobileOption('producto') & headerGA4Click('click', 'producto', 'header')"
          :class="{ active: getActiveSection === 'producto' }"
          class="mobile-menu-option"
        >
          <h2>PRODUCTO</h2>
        </div>
        <div
          @click="selectMobileOption('retailers') & headerGA4Click('click', 'donde comprar', 'header')"
          :class="{ active: getActiveSection === 'retailers' }"
          class="mobile-menu-option"
        >
          <h2>DÓNDE COMPRAR</h2>
        </div>
        <div
          @click="selectMobileOption('elaboracion') & headerGA4Click('click', 'elaboracion', 'header')"
          :class="{ active: getActiveSection === 'elaboracion' }"
          class="mobile-menu-option"
        >
          <h2>ELABORACIÓN</h2>
        </div>
        <div
          @click="selectMobileOption('ritualdeservido') & headerGA4Click('click', 'ritual del servido', 'header')"
          :class="{ active: getActiveSection === 'ritualdeservido' }"
          class="mobile-menu-option"
        >
          <h2>RITUAL DEL SERVIDO</h2>
        </div>
        <div
          @click="selectMobileOption('maridaje') & headerGA4Click('click', 'maridaje', 'header')"
          :class="{ active: getActiveSection === 'maridaje' }"
          class="mobile-menu-option"
        >
          <h2>MARIDAJE</h2>
        </div>
        <div
          @click="selectMobileOption('campaign') & headerGA4Click('click', 'campaña', 'header')"
          :class="{ active: getActiveSection === 'campaign' }"
          class="mobile-menu-option"
        >
          <h2>CAMPAÑA</h2>
        </div>
        <!-- <div
          @click="selectMacarioOption('macario') & headerGA4Click('click', 'sueña lindo', 'header')"
          :class="{ active: getActiveSection === 'macario' }"
          class="mobile-menu-option"
        >
          <h2>SUEÑA LINDO</h2>
        </div> -->
        <div class="social-networks">
          <a
            id="mobilefacebook"
            class="social-icon"
            target="_blank"
            rel="noopener"
            href="https://www.facebook.com/people/Tecate00/100083628819714/" @click="socialClick('Facebook','Interaction') & socialGA4Click('click', 'redes sociales :: facebook', 'header')"
            ><img :src="fbIcon" alt="Facebook"
          /></a>
          <a
            id="mobileinstagram"
            class="social-icon"
            target="_blank"
            rel="noopener"
            href="https://www.instagram.com/tecate0.0/" @click="socialClick('Instagram','Interaction') & socialGA4Click('click', 'redes sociales :: instagram', 'header')"
            ><img :src="inIcon" alt="Instagram"
          /></a>
          <a
            id="mobilepinterest"
            class="social-icon"
            target="_blank"
            rel="noopener"
            href="https://www.pinterest.com.mx/Tecate00/" @click="socialClick('Pinterest','Interaction') & socialGA4Click('click', 'redes sociales :: pinterest', 'header')"
            ><img :src="pintIcon" alt="Pinterest"
          /></a>
          <a
            id="mobiletwitter"
            class="social-icon"
            target="_blank"
            rel="noopener"
            href="https://twitter.com/tecatecerocero" @click="socialClick('Twitter','Interaction') & socialGA4Click('click', 'redes sociales :: twitter', 'header')"
            ><img :src="twIcon" alt="Twitter"
          /></a>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import tecateLogo from "@/assets/TECATELOGO.png";
import tecateLogo_black from "@/assets/TECATELOGO_NEGRO.png";
import fbIcon from "@/assets/redes-sociales/FACEBOOK_BLACK.png";
import twIcon from "@/assets/redes-sociales/TWITTER_BLACK.png";
import inIcon from "@/assets/redes-sociales/INSTAGRAM_BLACK.png";
import pintIcon from "@/assets/redes-sociales/PINTEREST_BLACK.png";
import { mapActions, mapGetters } from "vuex";
import tagFunctions from '@/utils/tagFunctions.js'

export default {
  name: "MobileMenu",
  computed: {
    ...mapGetters(["getActiveSection"]),
  },
  methods: {
    ...mapActions({
      setActiveSection: "setActiveSection",
    }),
    socialClick(socialNetwork, action){
      tagFunctions.evSocialNetworkPush(socialNetwork, action)
      fbq('trackCustom', 'RedSocial'+socialNetwork);
    },
    socialGA4Click(action, element, section) {
      tagFunctions.user_interactionPush(action, element, section)
    },
    headerGA4Click(action, element, section) {
      tagFunctions.user_interactionPush(action, element, section)
    },
    openMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    selectHomeOption(option) {
      this.setActiveSection({
        willScroll: true,
        section: option,
      });
    },
    selectMobileOption(option) {
      this.setActiveSection({
        willScroll: true,
        section: option,
      });
      this.$router.push({ path: option }).catch(err => {
    // Ignore the vuex err regarding  navigating to the page they are already on.
    if (
      err.name !== 'NavigationDuplicated' &&
      !err.message.includes('Avoided redundant navigation to current location')
    ) {
      // But print any other errors to the console
      throw err;
    }
  });
      this.openMenu();
    },
    // selectMacarioOption(option) {
    //   this.getActiveSection = option;
    //   if (option === 'macario') {
    //     this.$router.push('/macario');
    //   }
    // },
  },
  data() {
    return {
      isMenuOpen: false,
      tecateLogo,
      tecateLogo_black,
      fbIcon,
      twIcon,
      inIcon,
      pintIcon,
      isScrolled: false,
      scrollLevel: 100
    };
  },
  mounted(){
window.onscroll= (() => {
   let onScroll = () => {
       if ( window.pageYOffset > this.scrollLevel && !this.isScrolled ) {
      this.isScrolled = true
    } else if (window.pageYOffset <=this.scrollLevel && this.isScrolled) {
      this.isScrolled = false
    }
    }
   onScroll();
   return onScroll
})()

}};
</script>

<style scoped lang="scss">
@import "~@/styles/mobilemenu.scss";
</style>
